// Components
import Navbar from "../../components/Navbar";
import EditParametersComponent from "../../components/EditParametersComponent";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

export default function ParametersList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <div>
              <S.Title>Edição de Parâmetros</S.Title>
              <S.Description>
                Tela para editar os valores dos parâmetros.
              </S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
        <EditParametersComponent
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
        <GoTopoButtonWrapper>
          <ButtonV2
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            height="32px"
            leftIcon={IoChevronUp}
          >
            Topo
          </ButtonV2>
        </GoTopoButtonWrapper>
      </S.Wrapper>
    </>
  );
}
